export const refsFeedback = {
  reviewsList: document.querySelector('#feedback-list'),
  loader: document.querySelector('.loader-backdrop'),
};
